var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25 0.25H1.75C0.921573 0.25 0.25 0.921573 0.25 1.75V18.25C0.25 19.0784 0.921573 19.75 1.75 19.75H18.25C19.0784 19.75 19.75 19.0784 19.75 18.25V1.75C19.75 0.921573 19.0784 0.25 18.25 0.25ZM18.25 18.25H1.75V1.75H18.25V18.25ZM7 8.5V14.5C7 14.9142 6.66421 15.25 6.25 15.25C5.83579 15.25 5.5 14.9142 5.5 14.5V8.5C5.5 8.08579 5.83579 7.75 6.25 7.75C6.66421 7.75 7 8.08579 7 8.5ZM15.25 11.125V14.5C15.25 14.9142 14.9142 15.25 14.5 15.25C14.0858 15.25 13.75 14.9142 13.75 14.5V11.125C13.75 10.0895 12.9105 9.25 11.875 9.25C10.8395 9.25 10 10.0895 10 11.125V14.5C10 14.9142 9.66421 15.25 9.25 15.25C8.83579 15.25 8.5 14.9142 8.5 14.5V8.5C8.50193 8.11975 8.78811 7.80112 9.16598 7.75852C9.54384 7.71592 9.89378 7.96285 9.98031 8.33313C11.0142 7.63174 12.351 7.55891 13.455 8.14381C14.559 8.7287 15.2496 9.87563 15.25 11.125ZM7.375 5.875C7.375 6.49632 6.87132 7 6.25 7C5.62868 7 5.125 6.49632 5.125 5.875C5.125 5.25368 5.62868 4.75 6.25 4.75C6.87132 4.75 7.375 5.25368 7.375 5.875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.3cd790492da1d4b6a39ddf3085a9c15e.svg";
export { ForwardRef as ReactComponent };